import Image from "next/image";
import { ConditionName, ISubtitleIconsProps } from "../../../../../interfaces";
import { conditions } from "../../../../../helpers";
import IMAGES from "../../../../../images/importImages";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const SubtitleIcon = (props: ISubtitleIconsProps) => {

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { selectedSubtitle, videoElementSizeInfo, params } }) => ({ selectedSubtitle, videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`${conditions(ConditionName.isSelectedSubtitle) ? "fa-solid  fa-closed-captioning" : "fa-light fa-closed-captioning"} ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"} pl-text-white pl-cursor-pointer`}
                    {...props}
                />
            ) : (
                <Image
                    alt = "subtitle-icon"
                    src = { conditions(ConditionName.isSelectedSubtitle) ? IMAGES.subtitle : IMAGES.subtitleOutline}
                    className="pl-cursor-pointer"
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 13 : 22}
                    {...props}
                />
            )}
        </>
    )

}

export default SubtitleIcon;